<template>
  <div class="header_contain">
    <div class="headerbox">
      <div class="header_leftbox">
        <img :src="require('@/assets/logo.png')" class="header_logo"/>
        <div class="header_title">欢视助手</div>
      </div>
      <div class="header_rightbox">
        <div class="list_item"  :class="index==tabIndex? 'chooseitem':''" v-for="(item,index) in list" @click="choosetab(index)">{{ item }}</div>
         <div class="apkload_button" @click="downloadapk"  v-if="!isMobile">下载欢视助手TV版</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerbox",
/*  props:{
    tabIndex: {
      type: Number,
      default:0
    },
  },*/
  data() {

    return {
      tabIndex:0,
      list: ["首页", '使用教程'],
      isMobile:false
    }
  },
  mounted() {
    let userAgent = navigator.userAgent;
    this.isMobile = /mobile|android/i.test(userAgent);
  },
  methods: {
    //切换tab
    choosetab(index){
      this.tabIndex=index;
      this.$parent.tabChange(this.tabIndex)
    },
    downloadapk(){
      const url='https://dl-appstore.huan.tv/project/ott/tvhelper/TVhelper_general_1.0.0_20231023174019_release.apk';
      const link = document.createElement('a');
      link.href = url;
      link.download = ''; // 可选，设置下载文件的名称
      link.click();
    },
  }
}
</script>

<style scoped>
.header_contain {
  width: 90%;
  padding: 0 5%;
  height: 70px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.headerbox {
  width: 100%;
 max-width: 1400px;
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.header_leftbox {
  width: auto;
  height: auto;
  font-size: 20px;
  color: #ffffff;
  display: flex;
  justify-content: flex-start;
  align-items: center;

}

.header_logo {
  width: 50px;
  height: 50px;
}

.header_title {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 30px;
  margin-left: 12px;
}

.header_rightbox {
  width: auto;
  height: auto;
  font-size: 20px;
  color: #ffffff;
  display: flex;
  justify-content: flex-end;
  align-items: center;

}
.list_item{
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  padding:0px 15px;
}
.list_item:hover {
  cursor: pointer;
}
.chooseitem{
  color: #1457EF;
}
.apkload_button{
  width: 160px;
  height: 40px;
  line-height: 40px;
  background-color: #1457EF;
  border-radius: 20px;
  text-align: center;
  font-size: 16px;
  margin-left: 20px;
}
.apkload_button:hover {
  cursor: pointer;
}
/*@media screen and (max-width: 600px) {
  .headerbox {
    width: 100%;
    max-width: 600px;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }


  .header_logo{
    width: 30px;
    height: 30px;
  }
  .header_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 20px;
    margin-left: 12px;
  }
  .list_item{
    width: auto;
 !*   height: 34px;
    line-height: 34px;*!
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    background-color: #f7d600;
    min-width: 40px;
    margin-left: 4px;
    padding: 0px 4px;

  }
  .header_rightbox{
    font-size: 16px;
  }
  .apkload_button{
    width: 120px;
    height: 34px;
    line-height: 34px;
    background-color: #1457EF;
    border-radius: 17px;
    text-align: center;
    font-size: 12px;
    margin-left: 0px;

  }
}*/
</style>



// WEBPACK FOOTER //
// src/components/headerbox.vue